import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IEditeProfile {
    step: "info" | "SelectCard";
    UserInfo: IUserInfo
}

interface IUserInfo {
    Name: string;
    LastName: string;
    Gender: "Male" | "Female" | null
    NationalCode: string;
    BirthDay: string;
    Province: string;
    City: string;
    Address: string;
    PostalCode: string;
}

const initialState: IEditeProfile = {
    step: "info",
    UserInfo: {
        Name: "",
        LastName: "",
        Gender: null,
        NationalCode: "",
        BirthDay: "",
        Province: "",
        City: "",
        Address: "",
        PostalCode: ""
    }
}

const RequestCardsSlice = createSlice({
    name: " RequestCards",
    initialState,
    reducers: {
        setStep: (state, action: PayloadAction<string>) => {
            state.step = action.payload as any;
        },
        setValue: (state, actions: PayloadAction<string>) => {
            state.UserInfo = { ...state.UserInfo, ...actions.payload as any }
        },
        resetRequestForm: () => initialState
    }
})


export const { setStep, resetRequestForm, setValue } = RequestCardsSlice.actions;
export default RequestCardsSlice.reducer;